<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #toolbar>
      <router-link
        v-if="userCan('create.asset')"
        :to="{ name: 'AssetCreate' }"
        class="button button--primary poppins"
      >
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
        Asset
      </router-link>
    </template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__single">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Asset Name / Merchant Code"
              v-model="formData.search"
            />
          </div>
        </div>

        <div class="form-search__action">
          <div class="w-full flex">
            <BaseButton type="submit" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="default"
              @click="reset"
              >Reset Search</BaseButton
            >
          </div>
        </div>
      </form>

      <vue-good-table
        :key="tableKey"
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :isLoading="tableData.isLoading"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdown: perPageDropdown,
          dropdownAllowAll: false,
          setCurrentPage: tableData.currentPage,
          infoFn: tablePageInfo,
        }"
        styleClass="vgt-table striped bordered"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'synced_by' && props.row.synced_by && props.row.synced_at">
            {{ props.row.synced_by }} / {{ props.row.synced_at }}
          </span>
          <span v-else-if="props.column.field == 'deposit'">
            <button
              v-if="props.row.deposit == 0"
              type="button"
              class="w-40 border-green-500 button border border-solid hover:bg-green-500 hover:text-white transition-all duration-200 my-2 text-center text-green-500"
              @click="toggleSync(props.row.uuid, 1)"
            >
              <font-awesome-icon :icon="['fas', 'check-circle']" />
              Start
            </button>
            <button
              v-if="props.row.deposit == 1"
              type="button"
              class="w-40 border-red-500 button border border-solid hover:bg-red-500 hover:text-white transition-all duration-200 text-center text-red-500"
              @click="toggleSync(props.row.uuid, -1)"
            >
              <font-awesome-icon :icon="['fas', 'times-circle']" /> Stop
            </button>
          </span>
          <span v-else-if="props.column.field == 'withdraw'">
            <button
                v-if="props.row.withdraw == 0"
                type="button"
                class="w-40 border-green-500 button border border-solid hover:bg-green-500 hover:text-white transition-all duration-200 my-2 text-center text-green-500"
                @click="toggleSync(props.row.uuid, 2)"
            >
              <font-awesome-icon :icon="['fas', 'check-circle']" />
              Start
            </button>
            <button
                v-if="props.row.withdraw == 1"
                type="button"
                class="w-40 border-red-500 button border border-solid hover:bg-red-500 hover:text-white transition-all duration-200 text-center text-red-500"
                @click="toggleSync(props.row.uuid, -2)"
            >
              <font-awesome-icon :icon="['fas', 'times-circle']" /> Stop
            </button>
          </span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";

export default {
  data: () => {
    return {
      tableData: {
        columns: [
          {
            label: "Name",
            field: "name",
          },
          {
            label: "Merchant Code",
            field: "merchant_code",
          },
          {
            label: "Last Action",
            field: "synced_by",
          },
          {
            label: "Auto Deposit",
            field: "deposit",
          },
          {
            label: "Auto Withdraw",
            field: "withdraw",
          },
        ],
        sort_by: "name",
        sort_dir: "asc",
      },
    };
  },
  mixins: [showListMixin],
  methods: {
    reset() {
      this.formData.search = "";

      this.tableData.limit = 10;

      if (this.$route.query.search == undefined) {
        this.tableKey++;
      } else {
        this.tableData.currentPage = 1;
        this.$router.push({ name: "NexusSyncSetting" }).catch(() => {});
      }
    },
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.$router
          .replace({
            query: {
              search: this.formData.search,
            },
          })
          .catch(() => {});
      }
    },
    loadTableData() {
      const queryParams = this.$route.query;
      let searchParam = "";

      if (queryParams.search != undefined) {
        this.formData = { ...this.formData, ...this.$route.query };
        for (const key in queryParams) {
          searchParam += `&${key}=${queryParams[key]}`;
        }
      }

      this.tableData.isLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `/asset/syncable?page=${this.tableData.currentPage}&limit=${this.tableData.limit}&sort_by=${this.tableData.sort_by}&sort_dir=${this.tableData.sort_dir}${searchParam}`
        )
        .then((res) => {
          this.tableData.rows = res.data.data;
          this.tableData.totalRows = res.data.total;
        })
        .finally(() => {
          this.tableData.isLoading = false;
        });
    },
    toggleSync(id, status) {
      const url = process.env.VUE_APP_API_URL + "/asset/" + id + "/sync/" + status;
      let icon;

      if (status == 0) {
        icon = "error";
      } else {
        icon = "success";
      }

      this.tableData.isLoading = true;
      this.$http({
        method: "patch",
        url: url,
      })
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            
            this.$swal({
              position: "bottom-end",
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              title: res.data.message,
              icon: icon,
            });
            this.loadTableData();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.formError = [];

            if (error.response.status == 409) {
              this.formError[0] = "<pre>" + error.response.data + "</pre>";
            } else {
              for (var err in error.response.data) {
                for (var msg in error.response.data[err]) {
                  this.formError.push(error.response.data[err][msg]);
                }
              }
            }
          }
        })
        .finally(() => {
          
        });
    },
  },
};
</script>